import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { PageErrorState } from '@/components/layout/templates/ErrorState';

export function RouteErrorElement() {
  const error = useRouteError();
  const navigate = useNavigate();

  if (isRouteErrorResponse(error)) {
    return (
      <PageErrorState
        title={`${error.status} ${error.statusText}`}
        message={typeof error.data === 'string' ? error.data : undefined}
        onRetry={() => window.location.reload()}
        onBack={() => navigate(-1)}
      />
    );
  }

  return (
    <PageErrorState
      error={error instanceof Error ? error : undefined}
      onRetry={() => window.location.reload()}
      onBack={() => navigate(-1)}
    />
  );
}
